import request from '@/utils/request'
import URL from './urlTranslator'

/**
 * 加载基础信息-全量
 */
export function loadAllBasicInfo() {
  return request({
    url: URL.common.cacheAllBasicData,
    method: 'get'
  })
}
/**
 * 加载基础信息-初始化
 */
export function initCache() {
  return request({
    url: URL.common.initCache,
    method: 'get'
  })
}
/**
 * 加载基础信息-按需
 */
export function getPortionCacheVersions(data) {
  return request({
    url: URL.common.getPortionCacheVersions,
    method: 'post',
    data
  })
}

/**
 * 加载基础信息-特定的
 */
export function loadSpecificBasicInfo(entityKey) {
  return request({
    url: URL.common.cacheSpecificBasicData,
    method: 'get',
    params: { name: entityKey }
  })
}

/**
 * 更新基础信息-特定的
 */
export function updateCacheSpecificBasicData(entityKey) {
  return request({
    url: URL.common.updateCacheSpecificBasicData,
    method: 'post',
    params: { name: entityKey }
  })
}
